import { format, subDays, subHours, subMinutes } from 'date-fns';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

export const TIMEZONE = dayjs.tz.guess();

export const calculateTimeRange = (value: string) => {
  const now = new Date();
  let from = now;

  // Check if value is a non-null string before using ?.includes()
  if (value && typeof value === 'string') {
    if (value?.includes('m')) {
      from = subMinutes(now, parseInt(value.slice(0, -1), 10));
    } else if (value?.includes('h')) {
      from = subHours(now, parseInt(value.slice(0, -1), 10));
    } else if (value?.includes('d')) {
      from = subDays(now, parseInt(value.slice(0, -1), 10));
    }
  }

  return {
    from: format(from, 'yyyy/MM/dd HH:mm:ss'),
    to: format(now, 'yyyy/MM/dd HH:mm:ss'),
  };
};

export const formatNumberToTwoDigits = num => {
  if (num >= 1000000) {
    return `${(Math.floor(num / 100000) / 10).toFixed(1)}M`;
  } else if (num >= 1000) {
    const rounded = Math.floor(num / 100) / 10;
    return `${rounded}K`;
  } else {
    return `${Math.round(num)}`;
  }
};

export const formatTimeFilter = timeFilter => {
  return timeFilter
    ? timeFilter === '24h'
      ? '24hours'
      : timeFilter.replace('d', ' days').replace(/ /g, '')
    : '24hours';
};

export const getUrl = url => {
  if (url.includes('dev')) {
    return 'DEV';
  }
  if (url.includes('hf')) {
    return 'HF';
  } else if (url.includes('cyberqshield.seclogic.io')) {
    return 'PROD';
  } else {
    return 'UNKNOWN';
  }
};
